import React, { useState, useMemo, useEffect } from 'react';
import { Modal } from 'reactstrap';

const GenerateReportModal = ({
    isOpen,
    toggle,
    onGenerate,
    user
}) => {
    const { years, defaultYear } = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const signupYear = user?.createdAt 
            ? new Date(user.createdAt).getFullYear() 
            : null;
        const minYear = signupYear || currentYear - 10;
        const maxYear = Math.max(currentYear, minYear);
        const yearList = Array.from(
            { length: maxYear - minYear + 1 }, 
            (_, i) => maxYear - i
        );
        
        return { years: yearList, defaultYear: maxYear.toString() };
    }, [user?.createdAt]);
    
    const [selectedYear, setSelectedYear] = useState(defaultYear);

    useEffect(() => {
        if (isOpen) {
            setSelectedYear(defaultYear);
        }
    }, [isOpen, defaultYear]);

    const handleGenerate = () => {
        if (onGenerate && selectedYear) {
            onGenerate(selectedYear);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            centered
            className="cm_g_modal_wrapper"
            backdrop="static"
            keyboard={false}
        >
            <div className='cm_g_modal_header'>
                <h3>Generate Report</h3>
                <span onClick={toggle}>
                    <i className='fa-solid fa-xmark'></i>
                </span>
            </div>

            <div className='cm_g_modal_body'>
                <div className='generate-report-content'>
                    <label className='generate-report-label'>Select Year</label>
                    <div className='generate-report-dropdown-wrapper'>
                        <select
                            className='generate-report-dropdown'
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value)}
                        >
                            {years.map((year) => (
                                <option key={year} value={year.toString()}>
                                    {year}
                                </option>
                            ))}
                        </select>
                        <i className='fa-solid fa-chevron-down generate-report-chevron'></i>
                    </div>
                </div>

                <div className='generate-report-actions'>
                    <button
                        onClick={toggle}
                        className='btn btn_cancel'
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleGenerate}
                        className='btn btn_primary'
                    >
                        Generate
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default GenerateReportModal;

